"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var LoaderThickness;
(function (LoaderThickness) {
    LoaderThickness["Thick"] = "+thick";
    LoaderThickness["Thin"] = "+thin";
})(LoaderThickness || (LoaderThickness = {}));
var Loader = function (props) {
    var _a = props.component, Component = _a === void 0 ? "div" : _a, thickness = props.thickness, componentAndUtilityProps = __rest(props, ["component", "thickness"]);
    var _b = distillUtilityClasses_1.default(componentAndUtilityProps), utilityClasses = _b[0], componentProps = _b[1];
    var classes = ["c-loader"];
    if (thickness) {
        classes.push(thickness);
    }
    if (props.className) {
        classes.push(props.className);
    }
    if (utilityClasses) {
        classes.push.apply(classes, utilityClasses);
    }
    return react_1.default.createElement(Component, __assign({ className: classes.join(" ") }, componentProps));
};
exports.Loader = Loader;
exports.Loader.displayName = "Loader";
exports.Loader.Thickness = LoaderThickness;
//# sourceMappingURL=Loader.js.map